import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';
import { dateI18n } from '@wordpress/date';

const formatDateLong = (ts) => {
  return dateI18n('j F Y H:i', ts * 1000);
};

const GreenuxApiSettings = {
  url: window.theme.greenuxServiceUrl
    ? window.theme.greenuxServiceUrl.replace(/\/+$/, '')
    : '',
};

domReady(() => {
  const { createApp, ref, onMounted } = Vue; //eslint-disable-line
  createApp({
    setup() {
      const frontData = ref({});
      function startRun(runId) {
        if (!GreenuxApiSettings.url) {
          frontData.value = {
            errorMessage: _x(
              'The greenux service is offline.',
              'results page',
              'vtx'
            ),
            errorExtra: _x(
              'We might be currently performing maintenance or experiencing high traffic.',
              'results page',
              'vtx'
            ),
          };
          return;
        }
        fetch(GreenuxApiSettings.url + '/run?uuid=' + runId)
          .then((response) => {
            if (response.status !== 200) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            if (data.greenuxStatus) {
              if (-2 === parseInt(data.greenuxStatus)) {
                frontData.value = {
                  errorMessage: _x(
                    'A timeout occurred while trying to validate the performance of the website.',
                    'results page',
                    'vtx'
                  ),
                };
              }
              if (-3 === parseInt(data.greenuxStatus)) {
                frontData.value = {
                  errorMessage: _x(
                    'There was an error while trying to validate the performance of the website.',
                    'results page',
                    'vtx'
                  ),
                };
              }
              if (
                window.executionSettings.greenuxServiceCron &&
                -1 === parseInt(data.greenuxStatus)
              ) {
                setTimeout(() => {
                  startRun(runId);
                }, 15000);
              }
            } else {
              // convert timestamp to local human-readable date: DD MONTH YYYY HH:MM (24h)
              if (data.run_timestamp) {
                data.run_timestamp = formatDateLong(data.run_timestamp);
                data.next_run_timestamp = formatDateLong(
                  data.next_run_timestamp
                );
              }
              frontData.value = data;
            }
          })
          .catch((error) => {
            frontData.value = {
              errorMessage: _x(
                'There was an error retrieving the website you want to validate the performance.',
                'results page',
                'vtx'
              ),
            };
            console.error('Error:', error);
          });
      }
      onMounted(() => {
        const processPath = window.location.pathname
          .split('/')
          .filter((n) => n);
        if (processPath && processPath.length > 0) {
          startRun(processPath.pop());
        } else {
          frontData.value = {
            errorMessage: _x(
              'There was an error retrieving the website you want to validate the performance.',
              'results page',
              'vtx'
            ),
          };
        }
      });
      return { frontData };
    },
  }).mount('#executionResults');
});
